import { useTranslation } from 'react-i18next';

interface FreshFishProps {
  onAddToCart: (item: { id: string; name: string; price: number; image: string }) => void;
}

const freshFishProducts = [
  {
    id: 'ff5',
    nameKey: 'products.bar',
    descKey: 'products.barDesc',
    price: 5000,
    unit: 'kg',
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/8f970d6ee27ea403240afdc23a874587.jpeg'
  },
  {
    id: 'ff4',
    nameKey: 'products.bossus',
    descKey: 'products.bossusDesc',
    price: 5000,
    unit: 'kg',
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/17b7a670d115eb7aa56e8f782b312c71.jpeg'
  },
  {
    id: 'ff12',
    nameKey: 'products.brochet',
    descKey: 'products.brochetDesc',
    price: 3500,
    unit: 'kg',
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/46fda513b29d0aa43b90f600709fe848.jpeg'
  },
  {
    id: 'ff11',
    nameKey: 'products.capitaine',
    descKey: 'products.capitaineDesc',
    price: 5000,
    unit: 'kg',
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/a6a594e167a970e2aa6f9052ef353ce7.jpeg'
  },
  {
    id: 'ff16',
    nameKey: 'products.carangue',
    descKey: 'products.carangueDesc',
    price: 3200,
    unit: 'kg',
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/9acb0549f49f36c31f836513522a5118.jpeg'
  },
  {
    id: 'ff3',
    nameKey: 'products.carpe',
    descKey: 'products.carpeDesc',
    price: 4500,
    unit: 'kg',
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/2a80a64a079377e31ff7b16fa6c9d132.jpeg'
  },
  {
    id: 'ff10',
    nameKey: 'products.crabes',
    descKey: 'products.crabesDesc',
    price: 2800,
    unit: 'kg',
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/bdc362a3a92e361bb209adbacea3ac5a.jpeg'
  },
  {
    id: 'ff1',
    nameKey: 'products.crevettes',
    descKey: 'products.crevettesDesc',
    price: 4500,
    unit: 'kg',
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/9455c86e2dc56e1d3f063bd6970ee26f.jpeg'
  },
  {
    id: 'ff6',
    nameKey: 'products.dorade',
    descKey: 'products.doradeDesc',
    price: 4500,
    unit: 'kg',
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/a3cbc6652e5be73ba86ecc479c6c4666.jpeg'
  },
  {
    id: 'ff14',
    nameKey: 'products.escargot',
    descKey: 'products.escargotDesc',
    price: 3000,
    unit: 'kg',
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/ac06f7a448871fb979db4c094a53703f.jpeg'
  },
  {
    id: 'ff18',
    nameKey: 'products.escargotCleaned',
    descKey: 'products.escargotCleanedDesc',
    price: 6500,
    unit: 'kg',
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/d742013393da45cfbbb9afe7a9693cf9.jpeg'
  },
  {
    id: 'ff9',
    nameKey: 'products.gambas',
    descKey: 'products.gambasDesc',
    price: 7500,
    unit: 'kg',
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/165bc46fe07162df3076b21d8b6010a0.jpeg'
  },
  {
    id: 'ff2',
    nameKey: 'products.machoiron',
    descKey: 'products.machoironDesc',
    price: 2800,
    unit: 'kg',
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/d36f4d976b335908266141c75134fb1b.jpeg'
  },
  {
    id: 'ff17',
    nameKey: 'products.mulet',
    descKey: 'products.muletDesc',
    price: 3500,
    unit: 'kg',
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/d2de1c1a89ef474e509d30c27dd135ff.jpeg'
  },
  {
    id: 'ff8',
    nameKey: 'products.sole',
    descKey: 'products.soleDesc',
    price: 7000,
    unit: 'kg',
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/731058439ee6a5462f6daa0dee0445d1.jpeg'
  },
  {
    id: 'ff15',
    nameKey: 'products.tilapia',
    descKey: 'products.tilapiaDesc',
    price: 2800,
    unit: 'kg',
    image: 'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/cc4479676ab12067fe2e041d312a2110.jpeg'
  }
];

export default function FreshFish({ onAddToCart }: FreshFishProps) {
  const { t } = useTranslation('common');

  return (
    <section id="fresh" className="py-12 sm:py-16 md:py-20 bg-gradient-to-b from-white to-teal-50/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 sm:mb-12 md:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-3 sm:mb-4">
            {t('freshFish.title')}
          </h2>
          <p className="text-sm sm:text-base md:text-lg lg:text-xl text-gray-600 max-w-3xl mx-auto px-4">
            {t('freshFish.description')}
          </p>
          <p className="text-sm sm:text-base md:text-lg lg:text-xl text-gray-600 max-w-3xl mx-auto px-4 mt-4">
            {t('freshFish.tagline')}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 sm:gap-6 md:gap-8" data-product-shop>
          {freshFishProducts.map((fish) => (
            <div key={fish.id} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <div className="relative h-48 sm:h-56 md:h-64 overflow-hidden">
                <img 
                  src={fish.image} 
                  alt={t(fish.nameKey)}
                  className="w-full h-full object-cover object-top"
                  onError={(e) => {
                    e.currentTarget.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="100" height="100"%3E%3Crect width="100" height="100" fill="%23e5e7eb"/%3E%3Ctext x="50%" y="50%" text-anchor="middle" dy=".3em" fill="%239ca3af" font-family="sans-serif" font-size="14"%3ENo Image%3C/text%3E%3C/svg%3E';
                  }}
                />
                <div className="absolute top-3 sm:top-4 right-3 sm:right-4 bg-teal-600 text-white px-2 sm:px-3 py-1 rounded-full text-xs sm:text-sm font-semibold">
                  {t('freshFish.fresh')}
                </div>
              </div>
              <div className="p-4 sm:p-5 md:p-6">
                <h3 className="text-base sm:text-lg md:text-xl font-bold text-gray-900 mb-2">{t(fish.nameKey)}</h3>
                <p className="text-gray-600 text-xs sm:text-sm mb-3 sm:mb-4 line-clamp-2">{t(fish.descKey)}</p>
                <div className="flex items-center justify-between mb-3 sm:mb-4">
                  <div className="min-w-0">
                    <span className="text-base sm:text-lg md:text-xl lg:text-2xl font-bold text-teal-600 break-words">
                      {fish.price.toLocaleString()}
                    </span>
                    <span className="text-gray-600 text-xs sm:text-sm ml-1">
                      {fish.unit === 'kg' ? t('freshFish.perKg') : t('freshFish.perPiece')}
                    </span>
                  </div>
                </div>
                <button
                  onClick={() => {
                    try {
                      onAddToCart({ ...fish, name: t(fish.nameKey) });
                    } catch (error) {
                      console.error('Error adding item to cart:', error);
                    }
                  }}
                  className="w-full bg-teal-600 text-white py-2.5 sm:py-3 rounded-full text-xs sm:text-sm md:text-base font-semibold hover:bg-teal-700 transition-colors flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-shopping-cart-line"></i>
                  {t('freshFish.addToCart')}
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
